<template>
    <div class="ao-vivo">
        <Header></Header>

        <div class="my-4">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="box-ao-vivo">
                            <div class="titulo-ao-vivo d-flex align-items-center">
                                <span class="txt-h-2 txt-blue-2">
                                    Sollicita
                                </span>
                                <div class="bg-colors-2 ms-2 p-2 w-100">
                                    <span class="txt-h-2 txt-white marcador-ao-vivo-branco d-flex align-items-center">
                                        AO VIVO
                                    </span>
                                </div>
                            </div>
                            <div class="conteudo-ao-vivo mt-4" v-if="aovivo != null">
                                <!-- TRANSMISSAO AO VIVO -->
                                <div class="row" v-if="aovivo.flAtivo == 'Sim'">
                                    <div class="col-12 col-md-8">
                                        <div class="videoWrapper embed-responsive embed-responsive-16by9">
                                            <iframe class="" id="ls_embed_1521030233" :src="aovivo.urlEmbedVideo" frameborder="0" scrolling="no" allowfullscreen></iframe>
                                        </div>
                                        <div class="mt-3">
                                            <span class="txt-h-5 txt-blue-2 marcador-ao-vivo-vermelho">AO VIVO</span>
                                            <p class="txt-h-2 txt-size-24 txt-blue-2">{{aovivo.nmEvento}}</p>
                                            <!--<p class="txt-h-4 txt-grey-2">{{aovivo.nmEvento}}</p>-->
                                        </div>

                                    </div>
                                    <div class="col-12 col-md-4">
                                        
                                        <div class="chat h-100 d-flex flex-column justify-content-between">
                                            <div id="div_LstMensagem" class="panel-body">
                                                <p class="regular txt-p txt-blue-2 p-2 mb-0" v-for="(msg,index) in lstMensagens" :key="index">
                                                    <span class="txt-w-bold txt-grey-2">{{msg.nmNome}}</span> -
                                                    {{msg.dsMensagem}}
                                                <small class="horario pull-right regular"><i class="fas fa-clock"></i> {{formatDateMensagem(msg.dtInclusao)}}</small>
                                                </p>
                                            </div>
                                            <div id="div_CadastroChat" class="" v-if="div_CadastroChat">
                                                <div class="form-group mb-0">
                                                    <input type="text" class="form-control" id="txt_nmApelidoChat" placeholder="Nome" maxlength="100" v-model="txt_nmApelidoChat" :disabled="!txt_nmApelidoChat_disabled">
                                                </div>

                                                <div class="form-group">
                                                    <input type="email" class="form-control" id="txt_dsEmailChat" placeholder="E-mail" maxlength="100" v-model="txt_dsEmailChat" :disabled="!txt_dsEmailChat_disabled">
                                                </div>

                                                <div class="regular checkbox">
                                                    <label>
                                                        <input id="ckb_aceitaTermos" type="checkbox" v-model="ckb_aceitaTermos"> Informo que aceito os <span @click="showModal = !showModal" class="txt-blue-2 txt-w-bold c-pointer">termos de uso</span>
                                                    </label>
                                                </div>
                                                <button id="btnParticipar" class="bold btn btn-blue btn-block" :disabled="!ckb_aceitaTermos" type="button" @click="participarChat">Participar do chat</button>
                                            </div>

                                            <div id="div_MensagemChat" class="hidden" v-if="div_MensagemChat">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" placeholder="Informe aqui a sua mensagem" id="txt_dsMensagem" maxlength="300" v-model="txt_dsMensagem" />
                                                    <p class="txt-p txt-blue-2 text-right txt-size-11"><strong id="caracteres">{{txt_dsMensagem.length}}</strong>/300 caracteres</p>
                                                </div>
                                                <button class="bold btn  btn-blue btn-block" type="button" @click="enviarMensagem">Enviar</button>

                                                <span class="regular pt-2 d-inline-block">Ver os <span @click="showModal = !showModal" class="txt-blue-2 txt-w-bold c-pointer">termos de uso</span></span>
                                                <span class="bold float-right pt-2 mt-0 d-inline-block txt-blue-2 c-pointer" @click="sairChat">Sair</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <!-- PROXIMA TRANSMISSAO -->
                                <div class="conteudo-ao-vivo-off d-flex flex-column align-items-center mt-5" v-else>
                                    <span class="txt-h-2 txt-blue-2">
                                        Transmissão {{aovivo.nmEvento}} está agendada para : {{formatDate(aovivo.dtTransmissao)}} ás {{formatTime(aovivo.hrTransmissao)}}
                                    </span>
                                    <div class="w-50 mt-4">
                                        <img class="w-100" :src="aovivo.urlImgFoto" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                    </div>
                                </div>
                            </div>
                            <!-- SEM TRASMISSAO -->
                            <div class="conteudo-ao-vivo-off d-flex flex-column align-items-center my-5" v-else>
                                <span class="txt-h-2 txt-blue-2">
                                    Não está acontecendo uma transmissão ao vivo no momento.
                                </span>
                                <p class="txt-h-4 txt-size-18 txt-blue-2 text-center mt-3 mb-0">
                                    Quando uma transmissão estiver ocorrendo,
                                </p>
                                <p class="txt-h-4 txt-size-18 txt-blue-2 text-center">
                                    você poderá saber checando este ícone <span class="marcador-ao-vivo-vermelho rounded bg-blue-2 txt-white p-2">AO VIVO</span> no menu principal.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <Modal :showModal="showModal" :size="'lg'" :titulo="'Termos de uso'" :name="'modal-termos'">
            <template slot="conteudo">
                <p class="regular mt-3">
                    Sendo um USUÁRIO você poderá utilizar o CHAT para realizar as suas INTERAÇÕES e, sobre isso, esclarecemos que você é e será o único responsável pelo conteúdo e pelas consequências destas INTERAÇÕES. Veja que nós não nos responsabilizamos e nem poderemos ser responsabilizados por nenhum conteúdo ou consequência das suas INTERAÇÕES.
                </p>
                <p class="regular">
                    Além disso, deixamos claro que não endossamos nenhum conteúdo de INTERAÇÃO ou qualquer opinião, recomendação ou conselho nelas eventualmente contido. Renunciamos, inclusive na forma que a lei determina, toda e qualquer responsabilidade ligada ao conteúdo das suas INTERAÇÕES.
                </p>
                <p class="regular">
                    Porém, ainda que assim seja, informamos que efetuaremos um controle sobre o conteúdo das suas INTERAÇÕES, pedimos o seu comprometimento em respeitar a proibição dos itens abaixo:
                </p>
                <ol class="regular">
                    <li>Conteúdo que seja ilegal, difamatório, calunioso, ofensivo, obsceno, pornográfico, indecente, vulgar, lascivo, sexualmente explícito, contendo assédio, ameaça, invasivo da privacidade ou que ofenda direitos individuais, abusivo, fraudulento ou de alguma maneira censurável, na forma da lei brasileira;</li>
                    <li>Conteúdo que possa se constituir em encorajar ou fornecer instruções para uma ofensa criminal, violar os direitos de qualquer parte ou violar qualquer lei local, estadual, nacional ou internacional;</li>
                    <li>Conteúdo que descreva, faça referências ou, de alguma maneira, mencione atos violentos, perigosos, ilegais e/ou criminosos;</li>
                    <li>Conteúdo que descreva, faça referências ou, de alguma maneira, mencione ódio ou discriminação a respeito de gênero, orientação sexual, raça, religião ou nacionalidade;</li>
                    <li>Conteúdo que seja prejudicial ou degradante à reputação das marcas ou nomes comerciais do GRUPO NEGÓCIOS PÚBLICOS ou de outras empresas que participam do GRUPO NEGÓCIOS PÚBLICOS ou de produtos/serviços dessas empresas.</li>
                </ol>
                <p></p>
            </template>
        </Modal>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Modal from '@/components/Modal'

    import moment from 'moment'
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'AoVivo',
        components: { Header, Footer, Modal},
        computed: {
            user() {
                return this.$store.state.user
            },
            aovivo() {
                return this.$store.state.aovivo
            },
        },
        data: function () {
            return {
                chat: null,

                // Chaves usadas no storage
                keyStorage_nmUsuario: 'Soll_nmUsuarioChat',
                keyStorage_dsEmail: 'Soll_dsEmailChat',
                keyStorage_idTransmissao: 'Soll_idTransmissao',
                keyStorage_flPodeparticipar: 'Soll_flPodeParticipar',

                // Dados do usuário no chat
                txt_nmApelidoChat: '',
                txt_dsEmailChat: '',

                txt_nmApelidoChat_disabled: false,
                txt_dsEmailChat_disabled: false,
                txt_idTransmissao: "",
                txt_dsMensagem: "",

                div_CadastroChat: true,
                div_MensagemChat: false,
                ckb_aceitaTermos: false,

                showModal: false,

                lstMensagens: [],
            }
        },
        methods: {
            load() {
                this.verificaStorage();
            },
            formatDate(date) {
                return moment(date).format('DD/MM/YYYY');
            },

            formatDateMensagem(date) {
                return moment(date).format('HH:mm');
            },

            formatTime(time) {
                return moment(time, 'hh:mm:ss').format('HH:mm');
            },

            setValorStorage(chave,valor) {
                if (typeof (Storage) !== "undefined") {
                    localStorage.setItem(chave, valor);
                }
            },

            getValorStorage(chave) {
                if (typeof (Storage) !== "undefined") {
                    return localStorage.getItem(chave);
                } else {
                    return null;
                }
            },

            verificaStorage() {
                let $this = this;

                if (!localStorage.getItem($this.keyStorage_flPodeparticipar)) {
                    $this.setValorStorage($this.keyStorage_flPodeparticipar, "false");
                }

                if (!localStorage.getItem($this.keyStorage_nmUsuario) && localStorage.getItem($this.keyStorage_nmUsuario) != "") {
                    $this.setValorStorage($this.keyStorage_nmUsuario, $this.user.usuario.nmUsuario);
                    $this.txt_nmApelidoChat = $this.getValorStorage($this.keyStorage_nmUsuario);
                }
                else {
                    if ($this.user.usuario.nmUsuario == "Ao Vivo Sollicita") {
                        $this.txt_nmApelidoChat = '';
                    }
                    else {
                        $this.txt_nmApelidoChat = $this.user.usuario.nmUsuario;
                    }
                }

                if ($this.user.usuario.dsEmail != "aovivo@sollicita.com.br") {
                    $this.txt_dsEmailChat = $this.user.usuario.dsEmail;
                    $this.txt_nmApelidoChat_disabled = true;
                }
                else {
                    if (!localStorage.getItem($this.keyStorage_dsEmail) && localStorage.getItem($this.keyStorage_dsEmail) != "") {
                        $this.setValorStorage($this.keyStorage_dsEmail, $this.user.usuario.dsEmail);
                        $this.txt_dsEmailChat = $this.getValorStorage($this.keyStorage_dsEmail);
                    }
                    else {
                        $this.txt_dsEmailChat = $this.user.usuario.dsEmail;
                    }
                }

                $this.verificaPodeParticiparChat();
            },

            verificaPodeParticiparChat() {
                let $this = this;
                if (localStorage.getItem($this.keyStorage_flPodeparticipar) == "true" &&
                    Boolean(localStorage.getItem($this.keyStorage_nmUsuario)) &&
                    Boolean(localStorage.getItem($this.keyStorage_dsEmail)) &&
                    localStorage.getItem($this.keyStorage_idTransmissao) == $this.txt_idTransmissao)
                {
                    $this.div_CadastroChat = false;
                    $this.div_MensagemChat = true;

                    //$(".panel-chat .panel-body").addClass("overflow-maior");
                    $this.carregarUltimasMensagens();

                    // signalR
                    $this.InitSignalR();
                }
                else {
                    $this.div_CadastroChat = true;
                    $this.div_MensagemChat = false;

                    //$(".panel-chat .panel-body").removeClass("overflow-maior");

                    $this.setValorStorage($this.keyStorage_idTransmissao, "");
                }
            },

            carregarUltimasMensagens() {
                let $this = this;
                axios.get(`${urlApi}/AoVivo/CarregarUltimasMensagens`, { params: { idTransmissao: $this.aovivo.idTransmissao } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstMensagens = [];
                            if (res.data.data.rows != null) {
                                $this.lstMensagens = res.data.data.rows;
                            }
                            $this.scrollMensagens();
                           
                        } else {
                            avisoErro("Não foi possível carregar as últimas mensagens");
                            $this.lstMensagens = [];
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar as últimas mensagens");
                        $this.lstMensagens = [];
                    });


            },

            scrollMensagens() {
                this.$nextTick(() => {
                    var yourEl = document.getElementById("div_LstMensagem");
                    yourEl.scrollTop = yourEl.scrollHeight;
                });
            },

            participarChat() {
                if (!this.verificaEmail(this.txt_dsEmailChat)){
                    avisoErro("Favor informar um e-mail válido");
                }

                if (this.txt_nmApelidoChat.length < 3 || this.txt_nmApelidoChat == "Ao Vivo Sollicita") {
                    avisoErro("Favor informar um nome");
                }

                if (this.txt_dsEmailChat == "aovivo@sollicita.com.br") {
                    avisoErro("Favor informar um e-mail pessoal");
                }

                if (this.ckb_aceitaTermos && localStorage.getItem(this.keyStorage_nmUsuario) && localStorage.getItem(this.keyStorage_dsEmail)) {
                    this.setValorStorage(this.keyStorage_flPodeparticipar, "true");
                    this.setValorStorage(this.keyStorage_idTransmissao, this.txt_idTransmissao);
                    this.verificaPodeParticiparChat();
                }
            },

            verificaEmail(email) {
                var sEmail = email;
                // filtros
                //var emailFilter = /^.+@@.+\..{2,}$/;
                var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

                var illegalChars = /[()<>,;:\\/"[\]]/;
                // condição
                if (!(mailformat.test(sEmail)) || sEmail.match(illegalChars)) {
                    return false;
                } else {
                    return true;
                }
            },

            sairChat() {
                this.setValorStorage(this.keyStorage_flPodeparticipar, "false");
                this.verificaPodeParticiparChat();
            },

            enviarMensagem() {
                if (this.txt_dsMensagem.length > 0 && localStorage.getItem(this.keyStorage_flPodeparticipar) == "true" && Boolean(localStorage.getItem(this.keyStorage_nmUsuario)) && Boolean(localStorage.getItem(this.keyStorage_dsEmail))) {
                    let $this = this;
                    var data = {
                        p_nmUsuario: localStorage.getItem($this.keyStorage_nmUsuario),
                        p_dsEmail: localStorage.getItem($this.keyStorage_dsEmail),
                        p_dsMensagem: $this.txt_dsMensagem,
                        p_idTransmissao: $this.aovivo.idTransmissao
                    };
                    axios.post(`${urlApi}/AoVivo/EnviarMensagem`, data, { showLoading: false })
                        .then(res => {
                            if (res.data.success) {
                                $this.txt_dsMensagem = "";
                                $this.scrollMensagens();
                            } else {
                                avisoErro("Não foi possível carregar as últimas mensagens");
                                $this.lstMensagens = [];
                            }
                        })
                        .catch(function () {
                            avisoErro("Não foi possível carregar as últimas mensagens");
                            $this.lstMensagens = [];
                        });
                }
            },


            InitSignalR() {
               

                try {
                    let $this = this;

                    var uri = 'https://localhost:44324/chathub';
                    //var uri = 'https://api.retornofacil.com.br/chathub';

                    var token = $this.user.accessToken;
                    var connection = new window.signalR.HubConnectionBuilder().withUrl(uri + '?p_idTransmissao=' + $this.aovivo.idTransmissao, { accessTokenFactory: () => token }).build();

                    connection.on("RecebeNovaMensagem", function (user, message, dtInclusao ) {
                        $this.lstMensagens.push({ nmNome: user, dsMensagem: message, dtInclusao: dtInclusao });
                        $this.scrollMensagens();
                    });

                    connection.start().then(function () {
                        /*console.log('Connetado!');*/
                    }).catch(function (err) {
                        return console.error('Erro: ', err.toString());
                    });

                    connection.hub.disconnected(function () {
                        setTimeout(function () {
                            console.log('Tentando Reconectar!');
                            connection.hub.start();
                        }, 5000);
                    });
                }
                catch
                {
                    /*console.log();*/
                }
            }

        },
        created: function () {
            
        },
        watch: {
            txt_nmApelidoChat: function () {
                this.setValorStorage(this.keyStorage_nmUsuario, this.txt_nmApelidoChat);
            },
            txt_dsEmailChat: function () {
                if (this.verificaEmail(this.txt_dsEmailChat)) {
                    this.setValorStorage(this.keyStorage_dsEmail, this.txt_dsEmailChat);
                }
                else {
                    avisoErro("Favor informar um e-mail válido");
                }
            },
            aovivo: function () {
                this.load();
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .box-ao-vivo, .box-ao-vivo-off {
        min-height: 42.5vh;

        .titulo-ao-vivo {
            .marcador-ao-vivo-branco::after {
                content: "\A";
                width: 15px;
                height: 15px;
                border-radius: 50%;
                background: color('colors','2');
                display: inline-block;
                margin: 0 10px;
                border: 4px solid #FFF;
                filter: blur(0.5px);
            }
        }

        .conteudo-ao-vivo {
            background: color('grey','3');
            box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);
            padding: 40px;
        }

        .conteudo-ao-vivo-off {
            min-height: 34vh;

            p {
                line-height: 35px;
            }
        }

        .marcador-ao-vivo-vermelho::after {
            content: "\A";
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: color('colors','2');
            display: inline-block;
            margin: 0 5px;
            filter: blur(1px);
        }
    }


    #div_LstMensagem {
        height: 430px;
        overflow: auto;

        p:nth-child(odd) {
            background: #efefef;
        }

        p:nth-child(even) {
            background: #FFF;
        }
    }

</style>

